import { UploadedFile } from './common';
import { Company } from './company';
import { Discussion } from './discussion';
import { Innovation } from './innovation';
import { KeyTag } from './key-tag';
import { Region } from './region';
import { Topic } from './topic';
import { User } from './user';

export enum PostStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export type RepeatUnit = 'days' | 'weeks' | 'months' | 'years';
export type EndsType = 'never' | 'on' | 'after';

export type RecurrenceOptions = {
  interval: number; // Repeat every X
  unit: RepeatUnit; // weeks, months, etc
  byWeekdays?: number[]; // 0..6, Sunday=0
  ends: EndsType;
  untilDate?: string | null; // when ends === "on"
  count?: number | null; // when ends === "after"
  start?: string; // optional: first event start (in case you want UNTIL to align)
};

export interface RSVPUser {
  rsvpUser: User;
  createdAt: Date;
}

export interface Post {
  id: string;
  status: PostStatus;
  title: string;
  body: string;
  banner?: UploadedFile;
  company?: Company;
  topics?: [Topic];
  regions?: [Region];
  excerpt?: string;
  createdBy?: User;
  createdAt?: string;
  publishedAt?: string;
  approvedBy?: User;
  approvedAt?: string;
  likes?: number;
  comments?: number;
  isLiked?: boolean;
  isPinned?: boolean;
  discussion?: Discussion;
  rejectDesc?: string;
  keyTags: KeyTag[];
  writtenBy?: User;
  isPublic: boolean;
  event: boolean;
  eventTimezone: string;
  eventStartDate: string;
  eventEndDate: string;
  eventRegistrationDate: string;
  eventLocation: string;
  allDay: boolean; // TODO:
  rsvp: boolean;
  rsvpList: RSVPUser[];
  innovationSpaceTag?: Innovation;
  recurrenceConfig?: string;
}

export interface PostBasic {
  id: string;
  title: string;
  body: string;
  banner?: UploadedFile;
  excerpt?: string;
  createdBy?: User;
  publishedAt?: string;
  likes?: number;
  comments?: number;
  status: PostStatus;
  isLiked?: boolean;
  keyTags: KeyTag[];
  writtenBy?: User;
  isPublic: boolean;
  event: boolean;
  eventTimezone: string;
  eventStartDate: string;
  eventEndDate: string;
  eventRegistrationDate: string;
  eventLocation: string;
  rsvp: boolean;
  rsvpList: RSVPUser[];
  allDay: boolean;
}

export interface LikePost {
  likePost: {
    postId: string;
    userId: number;
  };
}

export type FeaturedContentType = 'POST' | 'EVENT';
export type FeaturingType = 'INTERNAL' | 'EXTERNAL';

export interface FeaturedContent {
  id: string;
  content: Post;
  rank: number;
  type: FeaturedContentType;
  featureFor: FeaturingType;
  createdAt: string;
  updatedAt: string;
}
